const {
  typeSuggestionsRender,
  quickLinkRender,
  textSuggestionsSectionRender,
  popularSearchItemRender,
  productRender,
  plainProductRender,
  recentSearchItemRender,
} = window.BAO.TagalysLibrary

class TagalysApiSearch {
  constructor () {
    this.formData = new FormData()
    this.setupFormData()
  }

  setupFormData () {
    const config = window.tagalysConfiguration
    this.formData.append('q', 'unset')
    this.formData.append('request[]', 'details')
    this.formData.append('request[]', 'filters')
    this.formData.append('request[]', 'sort_options')
    this.formData.append('page', '1')
    this.formData.append(
      'identification[client_code]',
      config.api.credentials.clientCode,
    )
    this.formData.append(
      'identification[api_key]',
      config.api.credentials.apiKey,
    )
    this.formData.append('identification[store_id]', config.api.storeId)
    this.formData.append(
      'identification[api_client][vendor]',
      window.Tagalys.packageDetails.vendor,
    )
    this.formData.append(
      'identification[api_client][language]',
      window.Tagalys.packageDetails.language,
    )
    this.formData.append(
      'identification[api_client][version]',
      window.Tagalys.packageDetails.version,
    )
  }

  makeRequest (query, callback) {
    const request = new XMLHttpRequest()
    this.formData.set('q', query)
    request.open(
      'post',
      `${window.tagalysConfiguration.api.serverUrl}/v1/search`,
    )
    request.onload = () => {
      if (request.readyState === request.DONE) {
        const jsonResult = JSON.parse(request.responseText)
        callback.call(this, jsonResult.total)
      }
    }
    request.send(this.formData)
  }
}

class TagalysSearch extends window.BAO.CustomElement() {
  connectedCallback () {
    super.connectedCallback()
  }

  setupListeners () {
    super.setupListeners()

    // eslint-disable-next-line no-undef
    onTagalysReady(() => {
      this.initialise()
    })
  }

  initialise () {
    const searchInput = this.els.search.element
    const widgetResultCache = []
    const smartWidgetId = this.dataset.smartWidgetId

    // eslint-disable-next-line no-undef
    Tagalys.UIWidgets.SearchSuggestions.init(
      ['#header-search', '#desktop-search'],
      {
        searchResultsURL: '/pages/search-results',
        callbacks: {
          beforeAPICall (requestParams, helpers) {
            document
              .querySelector('.tag-SearchSuggestions_Main')
              ?.classList?.add('request-in-progress')
            return requestParams
          },
          onSuccessfulAPICall (response, helpers) {
            const searchResult = new TagalysApiSearch()
            const query = helpers.getEnteredSearchQuery()
            searchResult.makeRequest(query, total => {
              document.querySelectorAll('.tag-ResultTotal').forEach(span => {
                span.textContent = `Results (${total})`
              })
            })
            document
              .querySelector('.tag-SearchSuggestions_Main')
              ?.classList?.remove('request-in-progress')

            return response
          },
        },
        templates: {
          quickLinks: {
            render: quickLinkRender,
          },
          recentSearchItem: {
            render: recentSearchItemRender,
          },
          widget: {
            callbacks: {
              afterInitialRender (helpers) {
                const productWrapper = document.querySelector(
                  "[data-widget='smart-widget']",
                )

                if (widgetResultCache.length > 0) {
                  productWrapper.insertAdjacentHTML(
                    'beforeend',
                    widgetResultCache.join(''),
                  )
                  return
                }

                window.Tagalys.UIWidgets.SmartWidget.init(
                  "[data-widget='smart-widget']",
                  {
                    widgetId: smartWidgetId,
                    options: {
                      includeTagalysCSS: false,
                    },
                    callbacks: {
                      onSuccessfulAPICall (response, helpers) {
                        productWrapper.classList.remove('tagalys-namespace')
                        productWrapper.removeAttribute('id')

                        response.products.forEach((product, index) => {
                          if (index > 3) return
                          widgetResultCache.push(plainProductRender(product))
                        })

                        productWrapper.insertAdjacentHTML(
                          'beforeend',
                          widgetResultCache.join(''),
                        )

                        return response
                      },
                    },
                    templates: {
                      widget: {
                        render: () => {},
                      },
                    },
                  },
                )
              },
              afterEveryRender (helpers) {
                const searchAside = document.querySelector(
                  '.tag-SearchSuggestions_Aside',
                )

                if (
                  searchInput.value.length > 1 &&
                  helpers.hasTextSearchSuggestions()
                ) {
                  searchAside.classList.add('has-type-results')
                } else {
                  searchAside.classList.remove('has-type-results')
                  if (widgetResultCache.length > 0) {
                    document
                      .querySelector("[data-widget='smart-widget']")
                      ?.replaceChildren()
                    document
                      .querySelector("[data-widget='smart-widget']")
                      ?.insertAdjacentHTML(
                        'beforeend',
                        widgetResultCache.join(''),
                      )
                  }
                }
              },
            },
            options: {
              request: {
                products: {
                  limit: 24,
                },
              },
              hierarchySeparator: '➜',
              // selector: '.tag-Wrapper',
              position: false,
              minimumCharactersToShowSuggestions: 2,
              maxRecentSearchesCount: 5,
              maxTotalSearchesCount: 24,
              alignToSelector: false,
              inheritAlignmentElementWidth: false,
              includeTagalysCSS: false,
            },
            render (html, args) {
              const props = args.props
              const helpers = props.helpers
              const recentAndPopularSearches = helpers.getRecentAndPopularSearches()

              const markup = html`
                <div class="tag-SearchSuggestions">
                  <div class="tag-SearchSuggestions_Columns">
                    <aside class="tag-SearchSuggestions_Aside">
                      <section class="tag-SearchSuggestions_Results">
                        <div>
                          <h3 class="tag-SearchSuggestions_Header fz-15_21">
                            ${window.BAO.Utils.parseHtmlEntities(
                              window.TagalysTranslations?.popular_searches,
                            )}
                          </h3>
                          <ul>
                            ${recentAndPopularSearches.popularSearches
                              .slice(0, 5)
                              .map(
                                popularSearch =>
                                  html`
                                    <${args.templates.popularSearchItem}
                                      popularSearch=${popularSearch}
                                    />
                                  `,
                              )}
                          </ul>
                        </div>
                        <div>
                          <h3 class="tag-SearchSuggestions_Header fz-15_21">
                            ${window.BAO.Utils.parseHtmlEntities(
                              window.TagalysTranslations?.recent_searches,
                            )}
                          </h3>
                          <ul>
                            ${recentAndPopularSearches.recentSearches.map(
                              recentSearch =>
                                html`
                                  <${args.templates.recentSearchItem}
                                    recentSearch=${recentSearch}
                                  />
                                `,
                            )}
                          </ul>
                        </div>
                      </section>

                      <${args.templates.quickLinks} />
                    </aside>

                    <main class="tag-SearchSuggestions_Main">
                      ${helpers.exceedsMinimumCharactersToShowSuggestions()
                        ? html`
                            <${args.templates.typeSuggestions} />
                          `
                        : html`
                            <p
                              class="fz-15_28 tag-SearchSuggestions_Header-short"
                            >
                              ${window.BAO.Utils.parseHtmlEntities(
                                window.TagalysTranslations?.trending_products,
                              )}
                            </p>
                            <ul
                              class="products tag-SearchSuggestions_Products"
                              data-widget="smart-widget"
                            ></ul>
                          `}
                    </main>
                  </div>
                </div>
              `

              return markup
            },
          },
          textSuggestionSection: {
            render: textSuggestionsSectionRender,
          },
          product: {
            render: productRender,
          },
          typeSuggestions: {
            render: typeSuggestionsRender,
          },
          products: {
            render (html, args) {
              const props = args.props
              const products = props.helpers.getProducts()
              return html`
                <div class=${`products ${props.className}`}>
                  ${products.map((product, index) => {
                    if (
                      window.innerWidth <= 900 &&
                      index >=
                        window.tagalysConfiguration.settings
                          .suggestionsLimitMobile
                    ) {
                      return false
                    }
                    if (
                      window.innerWidth > 900 &&
                      index >=
                        window.tagalysConfiguration.settings
                          .suggestionsLimitDesktop
                    ) {
                      return false
                    }
                    return html`
                      <${args.templates.product}
                        key=${index}
                        product=${product}
                      />
                    `
                  })}
                </div>
              `
            },
          },
          popularSearchItem: {
            render: popularSearchItemRender,
          },
        },
      },
    )
  }
}

if (!customElements.get('tagalys-search')) {
  customElements.define('tagalys-search', TagalysSearch)
}
